import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { BellOff, Bell } from 'lucide-react';
import MemberLayout from '../../components/MemberLayout';
import { PageLoader, Spinner } from '../../components/ui';
import api, { errMsg } from '../../services/api';

export default function Unsubscribe() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/public/unsubscribe/${token}`).then(r => setInfo(r.data)).catch(err => setError(errMsg(err)));
  }, [token]);

  const set = async unsubscribed => {
    setBusy(true);
    try {
      await api.post(`/public/unsubscribe/${token}`, { unsubscribed });
      setInfo(i => ({ ...i, unsubscribed }));
      toast.success(unsubscribed ? 'You have been unsubscribed' : 'Welcome back! Notifications are on again.');
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <MemberLayout narrow>
      <div className="card p-7 text-center">
        {!info && !error && <PageLoader />}
        {error && <p className="text-sm text-red-600">{error}</p>}
        {info && (info.unsubscribed ? (
          <>
            <BellOff size={44} className="mx-auto text-gray-400" />
            <h1 className="mt-3 text-xl font-semibold text-navy-900">You're unsubscribed</h1>
            <p className="mt-2 text-sm text-gray-600"><strong>{info.email}</strong> will no longer receive {info.groupName} announcements or birthday emails. Account emails (like password resets) are still sent.</p>
            <button disabled={busy} onClick={() => set(false)} className="btn-outline mt-6">{busy && <Spinner size={16} />}Subscribe again</button>
          </>
        ) : (
          <>
            <Bell size={44} className="mx-auto text-navy-700" />
            <h1 className="mt-3 text-xl font-semibold text-navy-900">Unsubscribe from {info.groupName} emails?</h1>
            <p className="mt-2 text-sm text-gray-600">Hi {info.fullName.split(' ')[0]}, you'll stop receiving all announcements to <strong>{info.email}</strong>. You can instead choose which emails you want from your profile.</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <button disabled={busy} onClick={() => set(true)} className="btn-danger">{busy && <Spinner size={16} />}Unsubscribe from all</button>
              <Link to="/profile" className="btn-outline">Choose emails instead</Link>
            </div>
          </>
        ))}
      </div>
    </MemberLayout>
  );
}
